/* @ngInject */
const labels = () => {
  const self = {}

  self.title = 'Options'

  self.fields = {
    checkboxs: {
      backButton: 'Bouton de retour',
      calendar: 'Calendrier pour les date',
      scrollTop: 'Remonter en haut de la page',
      largeMode: 'Mode large',
      advancedSearch: 'Recherche avancée',
    },
    sliders: {
      autocompleteTimer: 'Temps avant la disparition de l\'autocomplétion',
      displayedItemNumber: 'Nombre d\'éléments à afficher',
      toastTimer: 'Temps d\'affichage des alertes',
    },
  }

  self.log = {
    search: {
      success: 'Les options ont bien été chargées.',
      failure: 'Impossible de récupérer les options personalisées.',
    },
    update: {
      success: 'Les options ont bien été mise à jour.',
      failure: 'Impossible de mettre à jour les options.',
    },
    save: {
      success: 'Les options ont bien été sauvegardée.',
      failure: 'Impossible de sauvegarder les options.',
    },
    delete: {
      success: 'Les options ont bien été supprimée.',
      failure: 'Impossible de supprimer les options.',
    },
  }

  self.general = 'Général'
  self.display = 'Affichage'

  return self
}

export default labels



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/resources/labels.resource.js